import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const FreshDeskCreateTicketModal = React.lazy(
  () => import("./fresh-desk-create-ticket.modal"),
);

const FreshDeskCreateTicket: iModalProps<
  typeof FreshDeskCreateTicketModal,
  {
    onAdded?: (pageId: string) => any;
    contactId?: string;
    conversationId?: string;
  }
> = {
  name: "fresh-desk-create-ticket",
  component: GenerateModalWithSuspense(FreshDeskCreateTicketModal),
};

export default FreshDeskCreateTicket;
